import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-rcr-exchange-error',
  templateUrl: './rcr-exchange-error.component.html',
  styleUrls: ['./rcr-exchange-error.component.scss'],
})
export class RcrExchangeErrorComponent {
  @Input() statueTitle: string;
  @Input() statusDisplayMessage: string;
  @Input() statusResolutionMessage: string;
  @Input() modalHasStatusSuccess: string;
  @Input() modalHasStatusError: boolean;
}
